"use strict";
var gallery = document.querySelector(".gallery"); // контейнер
var mainImage = document.getElementById("largeImg"); // велике фото
gallery.addEventListener("click", function(ev) {
    var link = ev.target;
    if (link.tagName === "IMG") link = link.closest("a");
    if (!link) return;
    ev.preventDefault(); // не відкриваємо нову сторінку
    mainImage.src = link.href;
});

//# sourceMappingURL=index.9f33596c.js.map
